import type { IconName } from '../core/Icon';
import { RoutineCategory } from '../../../domain/routine/enums';

/**
 * Correspondance entre les catégories de mission du domaine et les icônes ASCEND locales.
 * Le domaine ne connaît aucune icône ; cette table vit côté présentation uniquement.
 */
export const CATEGORY_ICON: Record<RoutineCategory, IconName> = {
  [RoutineCategory.mental]: 'mental',
  [RoutineCategory.sport]: 'mouvement',
  [RoutineCategory.health]: 'protection',
  [RoutineCategory.work]: 'focus',
  [RoutineCategory.organization]: 'recentrage',
  [RoutineCategory.growth]: 'elevation',
  [RoutineCategory.emotion]: 'vie',
  [RoutineCategory.relationship]: 'rayonnement',
  [RoutineCategory.journal]: 'clarte',
  [RoutineCategory.custom]: 'maitrise',
};